import type {
  Response,
  DateTotalCompletedActivitiesResponse,
} from '@/lib/apollo/query/getTotalCompletedActivitiesByDateForUser/query'
import { parseDate } from '@/utils/date'

import type {
  TransformedData,
  TransformedDateTotalCompletedActivitiesData,
} from './types'

export const toTransformedDateTotalCompletedActivitiesData = (
  dateTotalCompletedActivities: DateTotalCompletedActivitiesResponse,
): TransformedDateTotalCompletedActivitiesData => ({
  ...dateTotalCompletedActivities,
  date: parseDate(dateTotalCompletedActivities.date),
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : response.getTotalActivitiesByDateForUser.map(
        toTransformedDateTotalCompletedActivitiesData,
      )
